import styled from 'styled-components';
import Box from './Box';
import { GRID } from './constants';
import theme from './theme';
const Grid = styled(Box).withConfig({
  displayName: "Grid",
  componentId: "sc-1i6s5ye-0"
})(["", ";"], GRID);
Grid.defaultProps = {
  theme,
  display: 'grid'
};
Grid.propTypes = {
  ...Box.propTypes,
  ...GRID.propTypes
};
export default Grid;